import React from 'react';
import ReactTooltip from 'react-tooltip';

function UnlockIcon(props){
  let svg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='"
  svg = svg + props.color
  svg = svg + "' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z'/%3E%3C/svg%3E"

  return (
    <>
      <img style={{width: props.size+'px', height: props.size + 'px', paddingRight: props.paddingRight + 'px'}} src={svg}/>
    </>
  );
};

UnlockIcon.defaultProps = {
  size: 24,
  color: 'white',
  paddingRight: 0
}

export default UnlockIcon;